import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const TotalStaffReport = () => {
  const location = useLocation();
  const [adminmob, setAdminMob] = useState('');
  const [branchId, setBranchId] = useState('');
  const { totalStaffData } = location.state || { totalStaffData: [] };
  const [staffDataWithDetails, setStaffDataWithDetails] = useState([]);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const navigate = useNavigate();
const [schoolData, setSchoolData] = useState(null);
 const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');

      useEffect(() => {
                 const storedLanguage = localStorage.getItem('language') || 'English';
                 setLanguage(storedLanguage);
               }, []);
    
const fetchSchoolData = () => {
  const firebaseDatabaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`;

  fetch(firebaseDatabaseUrl)
    .then(response => response.json())
    .then(data => {
      setSchoolData(data); 
    })
    .catch(error => {
      console.error('Error fetching school data from Firebase:', error);
    }); 
};
    useEffect(() => {
            fetchSchoolData(); 
          }, );
  // Extract adminmob and branchId from location.search
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const adminmobFromQuery = queryParams.get('adminmob');
    const branchIdFromQuery = queryParams.get('branchId');

    if (adminmobFromQuery) {
      setAdminMob(adminmobFromQuery);
    }
    if (branchIdFromQuery) {
      setBranchId(branchIdFromQuery);
    }
  }, [location.search]);

// Fetch employee details when adminmob and branchId are available
useEffect(() => {
  if (!adminmob || !branchId || totalStaffData.length === 0) return;

  const fetchEmployeeDetails = async () => {
    const updatedStaffData = await Promise.all(
      totalStaffData.map(async (staff) => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${staff.mobile}.json`
          );
          console.log("response", response);

          const personaldetails = response.data?.Personaldetails;
          const currentTeacherData = response.data?.Currentteacher;

          return {
            ...staff,
            address: personaldetails?.Address || '', // Display the Address in the Address column
            dob: personaldetails?.DOB || '', // Display the DOB in the DOB column
            gender: personaldetails?.Gender || '',
            maritalStatus: personaldetails?.MaritalStatus || '',
            employeeId: currentTeacherData?.EmployeeID || '', // Display the Employee ID in the Employee ID column
            department: currentTeacherData?.Department || '', // Display the Department in the Department column
            employmentType: currentTeacherData?.EmploymentType || '', // Display the Employment Type in the Employee Type column
            doj: currentTeacherData?.DOJ || '', // Display the DOJ in the DOJ column
          };
        } catch (error) {
          console.error('Error fetching employee details:', error);
          return {
            ...staff,
            address: '',
            dob: '',
            gender: '',
            maritalStatus: '',
            employeeId: '',
            department: '',
            employmentType: '', 
            doj: '',
          };
        }
      })
    );
    setStaffDataWithDetails(updatedStaffData);
  };
  
  fetchEmployeeDetails();
  }, [adminmob, branchId, totalStaffData]);

  const handleClose = () => {
    navigate(-1); // Change '/profile' to the actual path of your profile page
  };


  const handlePrint = () => {
    const printContent = document.querySelector('.modal-content');
  
    if (printContent) {
      const cloneContent = printContent.cloneNode(true);
  
      const schoolName = cloneContent.querySelector('p'); 
      const otherDetails = cloneContent.querySelectorAll('p'); 
  
      otherDetails.forEach((p, index) => {
        if (index !== 0) { 
          p.style.fontWeight = 'normal'; 
        }
      });
      
      if (schoolName) {
        schoolName.innerHTML = `<h5 style="font-size: 16px; margin-top: 10px;">${schoolData.schoolName}</h5>`; // Increase the font size and set top margin
      }
  
      const printWindow = window.open('', '', 'height=600,width=800');
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Modal Content</title>
            <style>
              @page {
                size: A4 Landscape;
                margin: 3mm;
              }
              body {
                font-family: Arial, sans-serif;
                margin: 0; /* Remove body margin */
              }
              .modal-content {
                margin: 20px; /* Add margin to the modal content */
              }
              thead {
                            background-color: #F0F0F0; /* Set very light gray background color for <thead> */
              }
                            .title-print{
                            padding-top:0;
                            }
            </style>
          </head>
          <body>
            ${cloneContent.outerHTML} <!-- Include the modified outer HTML of the modal content -->
          </body>
        </html>
      `);
      printWindow.document.close(); 
      printWindow.focus(); // Focus the new window
      printWindow.print(); // Trigger print
      printWindow.close(); // Close the print window after printing
    } else {
      console.error('Print content not found');
    }
  };

  return (
    <div className="main-content-of-page" >
     
      <div style={{ width:'100%'}}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px', float:'right', right:0 }}>
     
  <button
    style={{
      backgroundColor: '#dc3545',
      color: '#fff',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      fontSize: '20px',
      marginRight: '10px', 
      fontWeight: 'bold',
    }}
    onClick={handleClose}
  >
    X
  </button>
  
  <button
    onClick={handlePrint}
    style={{
      padding: '5px 10px',
      backgroundColor: '#03365e',
      color: '#fff',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      width: '80px',
    }}
  >
    Print
  </button>
  </div>
</div>
     
 <div className='modal-content'
        style={{
          width: 'auto', minWidth:'94%',
          overflowX: 'auto',
        }}
      >

      <table
        className="printable-table"
        style={{
          marginTop: '10px',
          borderCollapse: 'collapse',
          width: '100%',
          border: '1px solid #ddd',
          boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        }}
      >
        <thead>
        {schoolData && (
                      <tr>
                        <th colSpan="11" style={{

                          color: 'black',
                          padding: '5px',
                          borderRadius: '10px 10px 0 0',
                          textAlign: 'center',
                          lineHeight: '0.5',
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          fontSize: '13px',
                           paddingBottom:'30px'
                        }}>
                          <p><strong><h5> {schoolData.schoolName}</h5></strong></p>
                          <p>{schoolData.sansthaName}</p>
                          <p>{language === "English" ? "Taluka:" : "तालुका:"} {schoolData.taluka} , {language === "English" ? "Jilha:" : "जिल्हा:"} {schoolData.jilha} </p>
                          <p style={{marginBottom:'25px'}}>{language === "English" ? "Mobile Number:" : "मोबाइल नंबर:"} {schoolData.mobileNumber} , {language === "English" ? "Email:" : "ईमेल:"} {schoolData.email}</p>
                          <span className="title-print" style={{ border:'1px solid black',textAlign: 'center',width:'310px',margin:'auto',backgroundColor:'black',color:'white',borderRadius:'5px', padding:'5px', marginTop:'25px', fontSize:'15px' }}>{language === "English" ? "Total Staff Report " : "एकूण कर्मचारी अहवाल"}</span>
                        </th>
                      </tr>
                    )}

          <tr style={{ backgroundColor: '#f0f0f0' }}>
            <th
              style={{
                padding: '2px',
                border: '1px solid black',
                backgroundColor: '#ecf0f1',
                textAlign: 'center',
                color: 'black',
              }}
            >
              {language === "English" ? "Sr No." : "अनु.क्र."}
            </th>
            <th
              style={{
                padding: '8px',
                border: '1px solid black',
                backgroundColor: '#ecf0f1',
                textAlign: 'center',
                color: 'black',
              }}
            >
               {language === "English" ? "Name" : "नाव"}
            </th>
            <th
              style={{
                padding: '8px',
                border: '1px solid black',
                backgroundColor: '#ecf0f1',
                textAlign: 'center',
                color: 'black',
              }}
            >
                {language === "English" ? "Mobile" : "मोबाईल"}
            </th>
            <th
              style={{
                padding: '8px',
                border: '1px solid black',
                backgroundColor: '#ecf0f1',
                textAlign: 'center',
                color: 'black',
              }}
            >
               {language === "English" ? "Address" : "पत्ता"}
            </th>
            <th
              style={{
                padding: '4px',
                border: '1px solid black',
                backgroundColor: '#ecf0f1',
                textAlign: 'center',
                color: 'black',
              }}
            >
               {language === "English" ? "DOB" : "जन्मतारीख"}
            </th>
            <th
              style={{
                padding: '8px',
                border: '1px solid black',
                backgroundColor: '#ecf0f1',
                textAlign: 'center',
                color: 'black',
              }}
            >
               {language === "English" ? "Gender" : "लिंग"}
            </th>
            <th
              style={{
                padding: '8px',
                border: '1px solid black',
                backgroundColor: '#ecf0f1',
                textAlign: 'center',
                color: 'black',
              }}
            >
             {language === "English" ? " Marital Status " : "वैवाहिक स्थिती"}
            </th>
            <th
              style={{
                padding: '8px',
                border: '1px solid black',
                backgroundColor: '#ecf0f1',
                textAlign: 'center',
                color: 'black',
              }}
            >
             {language === "English" ? "ID " : "आयडी"}
            </th>
            <th
              style={{
                padding: '8px',
                border: '1px solid black',
                backgroundColor: '#ecf0f1',
                textAlign: 'center',
                color: 'black',
              }}
            >
             {language === "English" ? "Department" : "विभाग"}
            </th>
            <th
              style={{
                padding: '8px',
                border: '1px solid black',
                backgroundColor: '#ecf0f1',
                textAlign: 'center',
                color: 'black',
              }}
            >
               {language === "English" ? "Employment type" : "रोजगाराचा प्रकार"}
            </th>
            <th
              style={{
                padding: '8px',
                border: '1px solid black',
                backgroundColor: '#ecf0f1',
                textAlign: 'center',
                color: 'black',
              }}
            >
             {language === "English" ? "DOJ" : "रुजु झालेली तारीख"}
            </th>
          </tr>
        </thead>
        <tbody>
          {staffDataWithDetails.map((staff, index) => (
            <tr
              key={index}
              style={{
                backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9',
              }}
            >
              <td style={{ padding: '8px', border: '1px solid black', textAlign: 'center' }}>
                {index + 1}
              </td>
              <td style={{ padding: '8px', border: '1px solid black', textAlign: 'center' }}>
                {staff.name}
              </td>
              <td style={{ padding: '8px', border: '1px solid black', textAlign: 'center' }}>
                {staff.mobile}
              </td>
              <td style={{ padding: '8px', border: '1px solid black', textAlign: 'center' }}>
                {staff.address}
              </td>
              <td style={{ padding: '8px', border: '1px solid black', textAlign: 'center' }}>
                {staff.dob}
              </td>
              <td style={{ padding: '8px', border: '1px solid black', textAlign: 'center' }}>
                {staff.gender}
              </td>
              <td style={{ padding: '8px', border: '1px solid black', textAlign: 'center' }}>
                {staff.maritalStatus}
              </td>
              <td style={{ padding: '8px', border: '1px solid black', textAlign: 'center' }}>
                {staff.employeeId}
              </td>
              <td style={{ padding: '8px', border: '1px solid black', textAlign: 'center' }}>
                {staff.department}
              </td>
              <td style={{ padding: '8px', border: '1px solid black', textAlign: 'center' }}>
                {staff.employmentType}
              </td>
              <td style={{ padding: '8px', border: '1px solid black', textAlign: 'center' }}>
                {staff.doj}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <style>
        {`
          /* General styling for main content and table */
          .main-content-of-page {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 20px;
            background-color: #f0f0f0;
            height: 100vh;
            overflow-y: auto;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
            border: 1px solid #e0e0e0;
          }

          /* For large screens and desktops (width greater than 1200px) */
          @media (min-width: 1200px) {
            .main-content-of-page h1 {
              font-size: 28px;
              width: 400px;
            }

            .printable-table {
              width: 80%;
            }

            .printable-table th, .printable-table td {
              padding: 15px;
              font-size: 16px;
            }

            button {
              font-size: 20px;
            }
          }

          /* For medium screens and laptops (width between 768px and 1200px) */
          @media (min-width: 768px) and (max-width: 1199px) {
            .main-content-of-page h1 {
              font-size: 24px;
              width: 350px;
            }

            .printable-table {
              width: 90%;
            }

            .printable-table th, .printable-table td {
              padding: 12px;
              font-size: 14px;
            }

            button {
              font-size: 18px;
            }
          }

          /* For smaller screens (width less than 768px) */
          @media (max-width: 767px) {
            .main-content-of-page {
              padding: 15px;
            }

            .main-content-of-page h1 {
              font-size: 18px;
              width: 100%;
            }

            .printable-table {
              width: 100%;
              font-size: 12px;
            }

            .printable-table th, .printable-table td {
              padding: 8px;
            }

            button {
              font-size: 16px;
              width: 100%;
            }
          }

          /* For print styles */
          @media print {
            .main-content-of-page {
              width: 100%;
              padding: 0;
              margin: 0;
            }

            .printable-table {
              width: 100%;
              border: 1px solid black;
            }

            .printable-table th, .printable-table td {
              padding: 10px;
            }

            .main-content-of-page h1 {
              visibility: visible;
              font-size: 20px;
              position: absolute;
              top: 5px;
              left: 50%;
              transform: translateX(-50%);
              margin: 0;
            }

            button {
              display: none;
            }
          }
        `}
      </style>
    </div>
    </div>
  );
};

export default TotalStaffReport;
